import { showCtConfirm } from "@conectate/components/ct-confirm.js";
import { getAuth } from "firebase/auth";

import { getAPIURLv2 } from "./Fetchv2";

export function toQueryString(obj: any) {
	var parts = [];
	for (var i in obj) {
		if (obj.hasOwnProperty(i) && obj[i] != undefined) {
			parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
		}
	}
	return parts.join("&");
}

export interface CtResponse<T = any> {
	response: Response;
	json: T;
}
export interface CtRequestError {
	status: number;
	error_type: string;
	error_msg: string;
}
export interface CtResponseError {
	response: Response;
	json: CtRequestError;
}

export interface IPagination {
	token?: string;
	limit?: number;
	skip?: number;
}

export interface IOptions {
	retry: number;
}

export function zget<T = any>(url: string, params?: any, mode?: "raw"): Promise<CtResponse<T>> {
	let parsedURL: URL;
	let idTokenPromise = getAuth().currentUser!.getIdToken();
	return new Promise((solve, err) => {
		idTokenPromise
			.then(async idToken => {
				if (mode == "raw") parsedURL = new URL(url);
				else parsedURL = new URL(getAPIURLv2() + url);
				if (params) parsedURL.search = toQueryString(params);
				let p = await fetch(parsedURL.href, {
					headers: {
						Accept: "application/json, text/javascript, */*; q=0.01",
						Authorization: `bearer ${idToken}`,
						"accept-language": navigator.language.substring(0, 2),
						"x-lang": navigator.language.substring(0, 2),
						"Content-Type": "application/json",
						"Cache-Control": "no-cache",
						"x-app-version": process.env.VERSION!,
						"x-app-build": process.env.BUILD!,
						"x-ats-id": window.app.localStorage.atsConfig?.id || "",
						"x-ats-name": window.app.localStorage.atsConfig?.title || "",
						"x-path": window.location.pathname + window.location.search,
						Pragma: "no-cache"
					},
					method: "GET",
					mode: "cors"
				});

				let jsonResult;
				if (p.status == 204) {
					solve({ response: p, json: {} as any });
				} else if (p.status == 429) {
					showCtConfirm(
						"Parece que has abusado del servicio",
						"Se te ha denegado el servicio temporalmente por un uso inadecuado. Vuelve más tarde. Si vuelves a abusar del uso del servicio podemos inhabilitar tu cuenta de forma temporal o definitiva."
					);
					err({ json: { status: p.status, code: 429 }, response: p });
				} else if (p.status >= 400) {
					let error = {};
					try {
						error = await p.json();
					} catch (e) {}
					err({ json: error, response: p });
				} else {
					jsonResult = await p.json();
					solve({ response: p, json: jsonResult });
				}
			})
			.catch(function (error) {
				console.log("SUPERR", error);
				err({
					json: {
						status: 0,
						error_msg: "No hay conexión a internet",
						error_type: 0,
						number: 0
					},
					response: {} as any
				});
			});
	});
}

export function zhttp<T = any>(url: string, method: "SEARCH" | "POST" | "PUT" | "DELETE" | "PATCH", body?: any, options?: IOptions): Promise<CtResponse<T>> {
	let idTokenPromise = getAuth().currentUser!.getIdToken();

	return new Promise((solve, err) => {
		if (typeof body == "object" && !(body instanceof FormData)) {
			body = JSON.stringify(body);
		}
		idTokenPromise
			.then(async idToken => {
				let p = await fetch(getAPIURLv2() + url, {
					headers: {
						accept: "application/json, text/javascript, */*;",
						authorization: `bearer ${idToken}`,
						"content-type": body instanceof FormData ? "" : "application/json",
						"cache-control": "no-cache",
						"x-app-version": process.env.VERSION!,
						"x-app-build": process.env.BUILD!,
						"x-lang": navigator.language.substring(0, 2),
						"x-ats-id": window.app.localStorage.atsConfig?.id || "",
						"x-ats-name": window.app.localStorage.atsConfig?.title || "",
						"x-path": window.location.pathname + window.location.search,
						Pragma: "no-cache"
					},
					body: body,
					method: method,
					mode: "cors"
				});
				let jsonResult: any;
				if (p.status == 204) {
					solve({ response: p, json: {} as any });
				} else if (p.status == 429) {
					showCtConfirm(
						"Parece que has abusado del servicio",
						"Se te ha denegado el servicio temporalmente por un uso inadecuado. Vuelve más tarde. Si vuelves a abusar del uso del servicio podemos inhabilitar tu cuenta de forma temporal o definitiva."
					);
					err({ json: { status: p.status, code: 429 }, response: p });
				} else if (p.status >= 400) {
					let error = {};
					try {
						error = await p.json();
					} catch (e) {}
					err({ json: error, response: p });
				} else {
					let cl = p.headers.get("content-length");
					let length = parseInt(cl != undefined ? cl : "10");
					jsonResult = length > 1 ? await p.json() : {};
					solve({ response: p, json: jsonResult });
				}
			})
			.catch(function (error) {
				console.error("SU", error);
				if (`${error}`.includes("fetch") && options && --options.retry > 0) {
					setTimeout(() => zhttp(url, method, body, options).then(solve).catch(err), 1200);
				} else {
					let msg = `${error}`;
					if (msg.includes("Failed to fetch")) msg = "No hay conexión a internet";
					err(error);
				}
			});
	});
}

// @ts-ignore
window.zget = zget;
// @ts-ignore
window.zhttp = zhttp;
